import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Get Search Summary
 * @param {string} text
 */
const getCourseSuggestions = (text: string): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const tokenId = Cookies.get(AUTH_TOKEN_KEY)
      const URL = routes.SEARCH + '/suggestions/courses?search=' + text
      const config = {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      }

      AxiosClient.get(URL, config)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    } catch (err) {
      reject(err)
    }
  })
}
export default getCourseSuggestions
